import React, { useEffect, useMemo } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import Theme from './Theme';

const offWhite = "rgba(255, 255, 255, 0.7)"

const AppThemeProvider = ({ children, primaryColor, secondaryColor }) => {
  // Memoize the theme so it only recalculates when colors change
  const currentTheme = useMemo(() => 
    Theme.get(primaryColor, secondaryColor), 
    [primaryColor, secondaryColor]
  );

  useEffect(() => {
    if (currentTheme && currentTheme.palette) {
      const root = document.documentElement;
      const { palette } = currentTheme;

      // Map MUI values to CSS Variables
      const rootStyles = {
        '--primary-main': palette.primary.main,
        '--primary-contrast': palette.primary.contrastText,
        '--secondary-main': palette.secondary.main,
        '--secondary-contrast': palette.secondary.contrastText,
        '--error-main': palette.error?.main || '#f44336',
        '--off-white': offWhite,
        '--shadow-1': currentTheme.shadows[1],
        '--shadow-4': currentTheme.shadows[4],
        // Add more as needed
      };

      Object.entries(rootStyles).forEach(([property, value]) => {
        root.style.setProperty(property, value);
      });
    }
  }, [currentTheme]);

  return (
    <ThemeProvider theme={currentTheme}>
      {children}
    </ThemeProvider>
  );
};

export default AppThemeProvider;
